import { html} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import {styles} from './header.styles';
import {LitElementStateful} from '@stefanholzapfel/lit-state';
import {State} from '../../loading/loading';
import {TranslateService} from '../../../services/translate.service';

@customElement('lit-header')
export class Header extends LitElementStateful<State> {
    @property({type: String})
    public currentRoute: string;

    constructor() {
        super();
        this.connectState(['app', 'currentRoute'], 'currentRoute');
    }

    static get styles() {
        return [
            styles
        ];
    }

    protected render() {
        return html`
            ${ TranslateService.translate(`pages.${this.currentRoute.substr(1)}.header`) }
        `;
    }
}
